// Australian date formatting utilities (DD/MM/YYYY)

/**
 * Format a date as DD/MM/YYYY (Australian standard).
 * Accepts ISO string, Date, or null/undefined.
 */
export const formatDateAU = (value) => {
  if (!value) return '—';
  try {
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return '—';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch {
    return '—';
  }
};

/**
 * Format with month name: DD MMM YYYY (e.g. "07 Mar 2026").
 */
export const formatDateAULong = (value) => {
  if (!value) return '—';
  try {
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return '—';
  }
};

/**
 * Format date + time: DD/MM/YYYY HH:mm
 */
export const formatDateTimeAU = (value) => {
  if (!value) return '—';
  try {
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return '—';
    return `${formatDateAU(d)} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  } catch {
    return '—';
  }
};
